<div #parent class="fh">
  <form #title class="search-box" (submit)="searchNow()">
    <div class="input-container white celo-input-outline">
      @if (canShow) {
        <mat-form-field class="appear_1" appearance="outline">
          <mat-label
            >Search <span class="capitalize">{{ type }}</span></mat-label
          >
          <input
            matInput
            #input
            type="text"
            [(ngModel)]="queryOriginal"
            (ngModelChange)="change()"
            name="search"
            autocomplete="off"
            cdkFocusInitial
          />
        </mat-form-field>
      }
    </div>
  </form>
  <div
    class="results-box"
    [style.height.px]="parent.offsetHeight - title.offsetHeight"
  >
    @if (results && results.length > 0) {
      <div class="results-list">
        <div class="results-title">Results</div>
        @for (result of results; track result) {
          <div
            matRipple
            class="result celo-hoverable p-3"
            data-testid="conversation-search-result"
            (click)="select(result)"
            [matRippleColor]="color"
          >
            <app-search-message-card
              [sender]="pMap[result.sentBy]"
              [message]="result"
              [highlightString]="queryOriginal"
            ></app-search-message-card>
          </div>
        }
      </div>
    }
    @if (searching) {
      <div>
        @if (!no_internet) {
          <app-empty-state
            [isLoading]="true"
            [message]="'Searching'"
          ></app-empty-state>
        }
        @if (no_internet) {
          <app-empty-state
            [type]="'no_internet'"
            [title]="'No Internet Connection'"
            [message]="'Celo needs an internet connection to safely fetch your messages.'"
          ></app-empty-state>
        }
      </div>
    }
    @if (!searching) {
      <div class="after-search">
        @if (results.length === 0) {
          <div class="empty font-grey font-13 t-center">
            <div class="empty-content">
              @if (!searched) {
                <div>
                  <img
                    src="../../../assets/search-conversation.svg"
                    class="mx-auto appear_anim_1"
                    alt=""
                  />
                  <div class="title appear_anim_2">
                    Search <span class="capitalize">{{ type }}</span>
                  </div>
                  <div class="subtitle appear_anim_3">
                    Enter a keyword to search the
                    @if (type) {
                      <span class="lowercase">{{ " " }}{{ type }}</span>
                    }
                    .
                  </div>
                </div>
              }
              @if (searched && !historyLimitReached) {
                <div class="empty-results">
                  @if (endReached) {
                    <div class="title appear_anim_1">- No results found -</div>
                  }
                  @if (!endReached) {
                    <div class="appear_anim_1">
                      <img
                        src="../../../assets/search-conversation.svg"
                        class="mx-auto"
                        alt=""
                      />
                      <div class="title">No results found</div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        @if (searched) {
          <div [ngClass]="{ 'loadmore mx-auto p-2': !historyLimitReached }">
            @if (historyLimitReached) {
              <div
                class="history-limit-banner"
                (appOnVisible)="onHistoryLimitBannerVisible()"
              >
                <div class="history-limit-title">
                  Free plan message history limit reached
                </div>
                <div class="history-limit-text">
                  Only messages from the last {{ historyLimitDays }} days are
                  included in search results. Unlock full access to search your
                  complete message history.
                </div>
                <button
                  mat-raised-button
                  class="history-limit-upgrade"
                  (click)="onHistoryLimitUpgradeClick()"
                >
                  UPGRADE
                </button>
              </div>
            }
            @if (!historyLimitReached) {
              <div>
                @if (oldestMessage && oldestMessage.sentOnUtc && !endReached) {
                  <div class="subtitle appear_anim_1">
                    until {{ oldestMessage.sentOnUtc | dateFormat: "longDate" }}
                  </div>
                }
                @if (!endReached && !searching) {
                  <button
                    mat-button
                    class="fw celo-primary-button appear_anim_2"
                    (click)="loadMore()"
                  >
                    <span class="t-center">LOAD MORE MESSAGES</span>
                  </button>
                }
                @if (endReached && results.length > 0) {
                  <div
                    class="p-3 t-center font-13 font-grey appear_anim_3 subtitle"
                  >
                    - That's all -
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
